import apiClient from '../../api/client'

const loadRef = async () => {
    return apiClient.getContentTable();
}

export default { loadRef };